import styled from 'styled-components';

export const BoundariesContainer = styled.div`
  margin-bottom: 2rem;
`;

export const StyledWrapper = styled.div`
  position: relative;
`;
